import './program.scss';
//react
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import format from 'date-fns/format';
import es from 'date-fns/locale/es';
//shared
import { DETAIL_PROGRAM } from '../shared/graphql/programs';
import { SkeletonProgram } from '../shared/components/skeleton-program/skeleton-program';
import Icon from '../shared/components/icon/icon';
//material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { sendPageView } from '../shared/services/analytics';

import { DataNotFound } from '../shared/components/data-not-found/data-not-found';
import { DATA_NOT_FOUND } from '../programs/constants/DataNotFound';

export default function Program() {
    const location = useLocation();
    useEffect(() => {
        sendPageView(location.pathname + location.search, "Detalle de programa");
    }, [location]);

    let imageProgram: string = 'https://fitpal-public.s3.amazonaws.com/Tipos_entrenamiento/new_images/1643045161186.png';
    const params = useParams();
    const programId = parseInt(params.id!);
    const { data, loading, error } = useQuery(DETAIL_PROGRAM, {
        variables: {
            id: programId,
        },
    });

    if (loading) return <SkeletonProgram></SkeletonProgram>;
    if (error) console.log(`Submission error! ${error.message}`);
    if (data && data.programById) {
        if (data.programById.calendars[0].program.new_image) imageProgram = data.programById.calendars[0].program.new_image;

    };

    return (
        <div className='container-program-detail'>
            <Grid container justifyContent={'center'}>
                <Grid item xs={4} sm={4} md={4} className='info-program'>
                    <img src={imageProgram} alt='fitpal' className='img-program' />
                    {/* <Rating name="read-only" value={data.programById.new_score} readOnly />
                        <h4 className='subtitle'>
                            {format(new Date(data.programById.start_date), "dd MMMM yyyy", { locale: es })} - {format(new Date(data.programById.end_date), "dd MMMM yyyy", { locale: es })}
                        </h4>
                        <h5>{data.programById.calendars.length} clases</h5> */}
                    <h1 className='title-program mb-1'>{data.programById.name}</h1>
                    <h4 className='description-program'>{data.programById.description}</h4>
                </Grid>
                <Grid item xs={8} sm={8} md={8} className='info-classes'>
                    <Grid container className='cards-class-program'>
                        {data.teacherProgramSubscription.map((calendar: any) => (
                            <Grid item xs={12} sm={12} md={12} my={12} key={calendar.calendar_program_id} className='class-program'>
                                <div className='card-class-program'>
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <h4>{calendar.classProgram.name}</h4>
                                        </Grid>
                                        <Grid item xs={6} className='date-program'>
                                            <h5 >
                                                {format(new Date(calendar.start), "EEEE',' dd 'de' MMMM yyyy '-' HH:mm", { locale: es })}
                                            </h5>
                                            <h5>
                                                <Grid container justifyContent={'end'} display={'flex'}>
                                                    <Icon name='user-check' width='25' height='25' color='#06BAA6' />
                                                    <span>{calendar.total_booked ?? 0} usuarios</span>
                                                </Grid>
                                            </h5>
                                        </Grid>
                                    </Grid>
                                    <div className='description-class-program'>
                                        <h4>Descripción</h4>
                                        <p>{calendar.classProgram.description}</p>
                                        {(calendar.zoomTeacher && calendar.zoomTeacher.zoom_host_link) && (
                                            <div className='content-button'>
                                                <Button color='primary' className='button-card' href={calendar?.zoomTeacher?.zoom_host_link} target="_blank">Ingresar a clase</Button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Grid>
                        ))}

                        {!data.teacherProgramSubscription.length && (
                            <Grid xs={12}>
                                <DataNotFound data={DATA_NOT_FOUND} />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}